export default function AboutSection() {
  return (
    <section className="w-full py-24 md:py-32 px-10 md:px-16 bg-background-50">
      <div className="w-full max-w-[1440px] mx-auto flex flex-col lg:flex-row gap-16 lg:gap-20 items-center">
        <div className="w-full lg:w-1/2 flex flex-col">
          <p className="text-xl md:text-2xl text-foreground-700 leading-relaxed max-w-lg">
            We are a dedicated engineering team with deep expertise in the iOS platform. Our approach combines clean architecture principles with performance optimization to deliver software that stands the test of time.
          </p>
          <p className="text-base text-foreground-500 leading-relaxed max-w-lg mt-6">
            Every system we build is designed for scalability and maintainability, ensuring that technical debt stays low and quality stays high throughout the entire development lifecycle.
          </p>

          <div className="mt-10">
            <span className="inline-block px-5 py-2 rounded-full bg-accent-100 text-accent-800 text-sm font-medium tracking-wide">
              Engineering Excellence
            </span>
          </div>
        </div>

        <div className="w-full lg:w-1/2">
          <div className="relative rounded-3xl overflow-hidden w-full h-[500px] md:h-[600px]">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20architectural%20material%20texture%2C%20smooth%20concrete-like%20surface%20with%20subtle%20warm%20amber%20undertones%2C%20minimalist%20abstract%20composition%20with%20soft%20shadows%2C%20layered%20geometric%20planes%2C%20no%20people%2C%20no%20text%2C%20diffused%20natural%20lighting%2C%20refined%20and%20elegant%20contemporary%20aesthetic%2C%20gentle%20gradient%20transitions%20between%20warm%20neutral%20tones&width=700&height=800&seq=about-abstract-02&orientation=portrait"
              alt="Abstract architectural texture representing engineering precision"
              title="Rm Software - Engineering precision and quality"
              className="w-full h-full object-cover"
            />
            <div className="absolute top-6 left-6">
              <span className="inline-block px-4 py-1.5 rounded-full bg-white/90 text-foreground-800 text-xs font-medium tracking-wide">
                iOS Platform
              </span>
            </div>
            <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/50 to-transparent"></div>
            <div className="absolute bottom-8 left-8">
              <p className="text-white text-lg font-medium">User-Centered Design</p>
              <p className="text-white/70 text-sm mt-1">Built for real-world usability</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}